import type { ReactNode } from "react";
import { BrandMark } from "../../app/Shell.js";

/** `end` sits opposite the brand mark. */
export function AuthLayout({ children, end }: { children: ReactNode; end?: ReactNode }) {
  return (
    <div className="auth">
      <div className="auth-brand">
        <BrandMark />
        {end}
      </div>
      <div className="auth-body">{children}</div>
      <div className="auth-glow" aria-hidden="true" />
    </div>
  );
}
